import { lowerCase, startCase } from 'lodash';

export const formatTitleCase = (status: string) => {
  return startCase(lowerCase(status || ''));
};
